import styled from "styled-components";

export const Wrapper = styled.div`
  min-width: 24px;
  width: 24px;
  height: 24px;
  margin-right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 12px;
    height: 12px;
  }
`;
